import { autorun, makeAutoObservable, runInAction } from "mobx";

export class LoadableMixIn {
  loadStore = false;
  isLoading = false;
  isLoaded = false;

  private _disposer?: () => void;
  private _initialized = false;

  constructor(private store: { dataCount: number; setData: () => Promise<void> }) {
    makeAutoObservable(this);
  }

  initReaction() {
    if (this._initialized) return;
    this._initialized = true;

    this._disposer = autorun(() => {
      if (!this.isLoaded && !this.isLoading) {
        this.isLoading = true;

        this.store.setData().finally(() => {
          runInAction(() => {
            this.isLoading = false;
            this.isLoaded = true;
            this.loadStore = true;
          });
        });
      }
    });
  }

  destroy() {
    this._disposer?.();
    this._disposer = undefined;
    this._initialized = false;
  }

  get getLoadStore() {
    return this.loadStore;
  }
}
